/** File automatically generated by 'update-version.js', do not edit. */
export const versionEnv = {
  version: '1.1.6-rc1',
  commitHash: '085771d923f4079929dfb4ce859fd170b071d282',
  buildDate: '2025-02-24T13:36:28.692Z'
};